import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Grid,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  Close,
  Save,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AddStock: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    stockName: '#0987654',
    stockQuantity: '',
    stockReturn: '',
    stockIssueNo: '',
    createdBy: '',
    createdDate: '',
    status: '',
    description: '',
  });

  const handleInputChange = (field: string) => (event: any) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Stock data:', formData);
    navigate('/stock');
  };

  return (
    <Dialog
      open={true}
      onClose={() => navigate('/stock')}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 }
      }}
    >
      <DialogTitle sx={{ 
        backgroundColor: 'primary.main', 
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Add New Stock
        </Typography>
        <IconButton
          onClick={() => navigate('/stock')}
          sx={{ color: 'white' }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Stock Name"
                value={formData.stockName}
                onChange={handleInputChange('stockName')}
                required
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: 'success.main',
                    },
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Stock Quantity</InputLabel>
                <Select
                  value={formData.stockQuantity}
                  label="Stock Quantity"
                  onChange={handleInputChange('stockQuantity')}
                >
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="20">20</MenuItem>
                  <MenuItem value="50">50</MenuItem>
                  <MenuItem value="100">100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Stock Return</InputLabel>
                <Select
                  value={formData.stockReturn}
                  label="Stock Return"
                  onChange={handleInputChange('stockReturn')}
                >
                  <MenuItem value="0">0</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="15">15</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Stock Issue No</InputLabel>
                <Select
                  value={formData.stockIssueNo}
                  label="Stock Issue No"
                  onChange={handleInputChange('stockIssueNo')}
                >
                  <MenuItem value="001">001</MenuItem>
                  <MenuItem value="002">002</MenuItem>
                  <MenuItem value="003">003</MenuItem>
                  <MenuItem value="004">004</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Created By"
                placeholder="Enter"
                value={formData.createdBy}
                onChange={handleInputChange('createdBy')}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Created Date"
                type="date"
                value={formData.createdDate}
                onChange={handleInputChange('createdDate')}
                InputLabelProps={{ shrink: true }}
                required
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth required>
                <InputLabel>Status</InputLabel>
                <Select
                  value={formData.status}
                  label="Status"
                  onChange={handleInputChange('status')}
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                label="Description (optional)"
                placeholder="Enter"
                multiline
                rows={3}
                value={formData.description}
                onChange={handleInputChange('description')}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          onClick={() => navigate('/stock')}
          sx={{ px: 3 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          startIcon={<Save />}
          sx={{ 
            px: 3,
            background: 'linear-gradient(45deg, #4A90E2 30%, #50C878 90%)',
          }}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddStock;



